import { IAMAPI, swoopAPI } from '@/api'

// data: {userName:string , password:string}
export const login = data => swoopAPI.post('/api/v1/auth/token', data)
export const loginSSO = data => swoopAPI.post('/api/v1/sso/auth/token', data)
export const logout = () => swoopAPI.post('/api/v1/auth/logout')
export const exchangeMfaLoginCode = (code, flowNonce) => IAMAPI.post('/api/v1/users/mfa-login/exchange', { code, flowNonce })
// data: {email:string}
export const resetPassword = email => swoopAPI.post('/api/v1/auth/resetPassword', { email })
